import { render, staticRenderFns } from "./LtkShare.vue?vue&type=template&id=98febf98"
import script from "./LtkShare.vue?vue&type=script&lang=ts&setup=true"
export * from "./LtkShare.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShareLinks: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/ShareLinks.vue').default})
